const $card = document.getElementById('downloadable-resource')
const $btn = document.body.querySelector('[data-resource-anchor-btn]')

const makeDownloadableResourceSelectReactive = () => {
    if (!$card) return
    
    // else
    // console.log($card)
    const $select = $card.querySelector('#download-lang')

    const $output = $card.querySelector('output')
    const $downloadButton = $output.querySelector('[data-download-button]')
    const $downloadSize = $output.querySelector('[data-output-file-size]')
    const $downloadExt = $output.querySelector('[data-output-file-ext]')

    $select.addEventListener('change', (e) => {
        const value = e.target.value
        const $option = $select.querySelector(`[value="${value}"]`)
        const dataset = $option.dataset
        
        const file = {
            size: dataset.fileSize,
            ext: dataset.fileExt,
            url: dataset.fileUrl
        }
        
        // console.log(file)
        
        $downloadButton.href = file.url
        $downloadSize.textContent = file.size
        $downloadExt.textContent = file.ext
    })
}



/* global IntersectionObserver */
const observeResourceStickyDownloadBtn = () => {
    if (!$card) return
    
    // else
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    }
    
    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            const targetInfo = entry.boundingClientRect
            const rootBoundsInfo = entry.rootBounds
            
            if (entry.isIntersecting) {
                $btn.classList.replace('visible', 'hidden')
            } else {
                $btn.classList.replace('hidden', 'visible')
            }
        })
    }
    
    const observer = new IntersectionObserver(callback, options)
    
    observer.observe($card)
}

export {
    makeDownloadableResourceSelectReactive,
    observeResourceStickyDownloadBtn
}